export default "__VITE_ASSET__CgXPDu0A__"